import { type ISearchElectionStates } from '@/helpers/types';

import { coreApiSlice } from '../apiSlice';

const searchApiSclice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getSearchElection: builder.mutation<ISearchElectionStates, { keywords: string[] }>({
			query: (body) => ({
				method: 'POST',
				url: '/Search',
				body,
			}),
		}),
	}),
});

export const { useGetSearchElectionMutation } = searchApiSclice;
